// extracted by mini-css-extract-plugin
var _1 = "SearchSectionTitle-moduleSearchSectionTitle__dPlCi";
export { _1 as "SearchSectionTitle" }
